export const ATTRIBUTE = {
    LIEA_TIMESTAMP: 12,
    CAMERA_TIMESTAMP: 13,
    PO_NUMBER: 78,
    CARRIER_NAME: 89,
    IS_LOADED: 108,
    OCR_TYPE: 135,
    CORRECTION_TYPE: 140,
    RESPONSIBILITY_CENTER: 229,
    UNIT_OF_MEASURE: 255,
    RAIL_DETECTION_TYPE: 286,
    YARD_EVENT_TYPE: 288,
    TRAIN_ID: 289,
}

// Picklist values for specific attributes
export const UNIT_OF_MEASURE = {
    IN: 162,
}

export const CORRECTION_TYPE = {
    OCR: 84,
    LPR: 85,
}
